import { onMounted, onUnmounted } from 'vue'

export function useStickyHeader(
  showStickyHeader: { value: boolean },
  element: { value: HTMLElement | null }
): void {
  const observer = new IntersectionObserver(
    entries => {
      const isVisible = entries[0].isIntersecting
      showStickyHeader.value = !isVisible
    },
    {
      root: null,
      threshold: 1.0,
    }
  )

  onMounted(() => {
    if (element.value) {
      observer.observe(element.value)
    }
  })

  onUnmounted(() => {
    observer.disconnect()
  })
}
